/**
 * Fetches conversation list for the current user (RULE §13: hooks for API interaction).
 * Returns conversations, loading, error, refetch.
 */
import { useState, useEffect, useCallback } from 'react';
import messagingService from '../services/messagingService';

function useConversations() {
  const [conversations, setConversations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchConversations = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      const data = await messagingService.getConversations({ page_size: 50 });
      const list = Array.isArray(data) ? data : (data?.results ?? []);
      setConversations(list);
    } catch (err) {
      setError(err?.response?.data?.message || err.message || 'Failed to load conversations');
      setConversations([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchConversations();
  }, [fetchConversations]);

  return { conversations, loading, error, refetch: fetchConversations };
}

export default useConversations;
